import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HtmlAsText from "./createmode/HtmlAsText";
export const StudentInnerHeader = () => {
  const { book } = useSelector((state) => state.entities.student);
  const { reader } = useSelector((state) => state.ui.reader);
  const { loaders } = useSelector((state) => state.ui);
  const { chapter, section } = reader;
  const currentChapter = book.chapters[chapter];
  const [showFilter, setShowFilter] = useState(false);
  const [universities, setUniversities] = useState([]);
  useEffect(() => {}, [reader]);
  return (
    <div className="inner_header_std">
      <div className="row align-items-center space-between">
        <div className="col-lg-12">
          <div className="content_wrap">
            {loaders.bookLoader ? (
              <>
                <div className="content-skeleton mb-0 inner-head-load"></div>
                <div
                  className="content-skeleton mb-0 inner-head-load"
                  style={{ width: "19.6%" }}
                ></div>
              </>
            ) : (
              <>
                <h5>
                  {book?.name}:{" "}
                  <HtmlAsText
                    htmlContent={
                      currentChapter?.title?.slice(0, 7) + "..." || " "
                    }
                  />
                  <span>{book?.author}</span>
                </h5>
                <h5>
                  CHAPTER {chapter + 1}, SECTION {section + 1}
                </h5>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
